<span *ngIf="!loading" (click)="goToTeacherMenu()" class="pointer">Teacher Menu</span>
<app-loading-spinner *ngIf="loading" [text]="" [noMargin]="true"></app-loading-spinner>